import { useTutorial } from './context';

/**
 * Returns the letter currently shown as a floating `KeyCap` hint, or `null`
 * when no step is awaiting a keypress hint.
 */
export const useTutorialKeyHint = (): string | null => {
  const { activeKeyHint } = useTutorial();

  return activeKeyHint;
};
